module.exports = global["surveylab_survey_pageSelect"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./page-select.ts");